// This enum uses statuses from react-query QueryStatus and FetchStatus types
export enum RequestStatus {
    Idle = 'idle',
    Pending = 'pending',
    Error = 'error',
    Success = 'success',
}
